import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import RidersMap from "./RidersMap";
import { adminActions } from "../../../redux/actions";

export default function CourierMapWrapper({ rider, rider_company_id="" }) {
  const rider_id = rider?.id;
  const company_id = rider_company_id;
  const dispatch = useDispatch();
  const [locationList, setLocationList] = useState({});
  
  useEffect(() => {
    if (!window?.firebase?.database) {
      console.error("Firebase is not initialized");
      return;
    }

    const locationRef = window.firebase.database().ref(company_id + "/");
    console.log('locationRef',locationRef);
    
    const listener = locationRef.on(`value`, (snapshot) => {
      console.log('snapshot',snapshot);
      
      const location = snapshot.val();
      setLocationList(location);
      // eslint-disable-next-line react-hooks/exhaustive-deps
      dispatch(adminActions.getLocationList({ location }));
    });

    // Cleanup listener on unmount
    return () => {
      if (locationRef) {
        locationRef.off(`value`, listener);
      }
    };
  }, [dispatch, company_id]);

  return (
    <div>
      <RidersMap id={rider_id} locationList={locationList} />
    </div>
  );
}
